import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-waiting-for-croupier',
    imports: [CommonModule],
    templateUrl: './waiting-for-croupier.component.html',
    styleUrl: './waiting-for-croupier.component.scss'
})
export class WaitingForCroupierComponent {}
